import { Currency } from "../../utils/Currency";
import { AllocationHelper } from "./AllocationHelper";
import { DateUtil } from "../../utils/DateUtil";
/*
Custom Order Strategy
The CustomOrderStrategy allows you to define a custom order for bill allocation based on specific criteria.

Explanation:
- Custom Ordering: Define any sorting logic based on business needs.
- Flexible Allocation: Allocation logic remains consistent; only the bill processing order is customizable.
*/
export class CustomOrderStrategy {
    compareFunction;
    constructor(compareFunction) {
        this.compareFunction = compareFunction;
    }
    apply(currentDate, deposit, bills, paymentPriority) {
        let remainingAmount = deposit.amount.clone();
        const allocations = [];
        let sortedBills = bills.all.filter((bill) => bill.isOpen(currentDate) && !bill.isPaid()).sort(this.compareFunction);
        if (deposit.applyExcessToPrincipal) {
            const excessAppliedDate = DateUtil.normalizeDate(deposit.excessAppliedDate || deposit.effectiveDate);
            sortedBills = sortedBills.filter((bill) => bill.openDate.isBefore(excessAppliedDate) || bill.openDate.isEqual(excessAppliedDate));
        }
        for (const bill of sortedBills) {
            if (remainingAmount.round().isZero())
                break;
            const { allocation, remainingAmount: newRemainingAmount } = AllocationHelper.allocateToBill(deposit, bill, remainingAmount, paymentPriority);
            allocations.push(allocation);
            remainingAmount = newRemainingAmount;
        }
        const totalAllocated = deposit.amount.subtract(remainingAmount);
        return {
            effectiveDate: DateUtil.normalizeDate(deposit.effectiveDate),
            depositId: deposit.id,
            totalAllocated,
            allocations,
            unallocatedAmount: remainingAmount,
            excessAmount: Currency.Zero(), // Adjust excess handling as needed
        };
    }
}
